import type { GraphicsContent, Property } from "./core";
import type { Schematic } from "./schematic";
import type { Symbol } from "./symbol";
import type { Layout } from "./layout";
import type { Circuit } from "./circuit";

// # Content Type Union
export type Content = Schematic | Symbol | Layout | GraphicsContent | Circuit;

// # Content Kind Tags
export type ContentKind = Content["contentKind"];

const __ = (c: Content): Array<Property> | undefined => c.properties;
